module.exports = {
    language: {
        name: '中文'
    },
    button: {
        login:"登　录",
        add: "新增",
        query: "查询",
        details:"详情",
        send:"发布",
        loaction:"获取定位信息",
        save: "保存",
        update: "编辑",
        reset: "重置",
        exportUpgradeResult: "导出",
        confirm: "确定",
        cancel: "取消",
        delete: "删除",
        addCcn: "新增控制器软件CCN号",
        pushCcnTable: "下发点表",
        upCcnVersion: "升级版本",
        copyCcn: "点表复制",
        createUser:"创建用户",
        createRole:"创建新角色",
        editRole:"编辑角色",
        OperatingLicense:"操作授权",
        createFirstLevelMenu:"创建一级菜单",
        createSecondLevelMenu:"创建二级菜单",
        editFirstLevelMenu:"编辑一级菜单",
        editSecondLevelMenu:"编辑二级菜单",
        addCountry:"新增国家/地区",
        addRegion:"新增大区",
        addCustomerCenter:"新增客户中心",
        addProvince:"新增省份",
        addLiaisonOffice:"新增联络处",
        updateCountry:"修改国家/地区",
        updateRegion:"修改大区",
        updateCustomerCenter:"修改客户中心",
        updateProvince:"修改省份",
        updateLiaisonOffice:"修改联络处",
        addCustomer:"新增客户",
        updateCustomer:"修改客户",
        managementArea:"地区管理",
        addAirCompressionStation:"新增空压站",
        editAirCompressionStation:"修改空压站",
        addProductLine:"新增产品线",
        addProductCategories:"新增产品大类",
        addSmallClassProduct:"新增产品小类",
        addMachineType:"新增机型",
        upload:"点击上传",
        addGateway:"新增网关",
        gatewayBinding:"网关绑定",
        relieveGateway:"网关解绑",
        QRcode:"二维码",
        resendPointTable:"重发点表",
        addAgency:"新增经销商",
        updateAgency:"修改经销商",
        bulkImport:"批量导入",
        simImport: "sim卡批量导入",
        bulkImportExpertAdvice:"导入专家建议",
        bulkImportServiceType:"导入服务类型",
        bulkImportAgency:"批量导入经销商",
        bulkImportCustomer:"批量导入客户",
        startImport:"开始导入",
        chooseFile:"选择文件",
        uploadImg:"上传图片",
        Statistics:"统计",
        exportReport:"导出报表",
        createPushMessage:"新增商业推送信息",
        exportCustomerList:"导出客户列表",
        exportAgencyList:"导出经销商列表",
        exportAll:"全部导出",
        
        exportRecord:"导出记录",
        exportDetail:"导出详细",
        export:"导出",
        dprm:"确定推送例行保养？",
        dsl:"确认服务丢失？",
        addBrand:"新增品牌",
        editBrand:"修改品牌",
        viewExpertAdvice:"查看专家建议",
        sendEmail:"发送邮件",
        batchAdd:"批量添加",
    },
    tips:{
        NA:"无数据",
        success:"成功",
        Error:"错误",
        importFail:"导入失败",
        requestError:"接口请求失败",
        deleteSuccess:"删除成功",
        enterCorrectEmail:"请输入正确的邮箱!",
        validate:"请输入完整!",
        selectRole:"请选择角色!",
        createSuccess:"创建成功",
        updateSuccess:"更新成功",
        activeSuccess:"激活成功",
        freezingSuccess:"冻结成功",
        enterAccount:"请输入账号",
        enterUserName:"请输入用户名",
        enterEmail:"请输入邮箱地址",
        enterSort:"排序不能为空",
        enterDescribe:"描述不能为空",
        enterUrl:"链接不能为空",
        enterName:"名称不能为空",
        enterParentMenu:"请选择父级菜单",
        noPerimission:"未配置菜单权限，请联系管理员!",
        saveSuccess:"保存成功",
        saveFailed:"保存失败",
        oprationSuccess:"操作成功",
        bindSuccess:"绑定成功",
        relieveSuccess:"解绑成功",
        importSuccess:"导入成功",
        pushSuccess:"推送成功",
        loginFailed:"用户名或密码错误",
        needed:"不能为空",
        mustNumebr:"请输入数字",
        uploadInfo:"上传图片大小不能超过 5MB!",
        uploadInfo2:"只能上传jpg/png文件，且不超过500kb",
        uploadInfo3:"上传图片只能是jpg / png / bpm格式!",
        uploadInfo4:"上传文件大小不能超过 10MB!",
        isRelieveGateway:"确定解绑吗？",
        isRelease:"确定发布吗？",
        enterPwd:"请输入密码",
        enterAgain:"请再次输入密码",
        pwdTips:"密码至少包含大写字母、小写字母、数字、符号中任意三个，且长度不能低于8位",
        twoPawNotSanme:"两次输入密码不一致",
        warning:"警告",
        selectMonitoringParameters:"请选择监控参数！",
        selectDate:"请选择日期",
        selectTime:"请选择时间",
        sendSuccess:"发布成功",
        fillServiceNumber:"请填写服务单号！",
        enterRoleName:"请输入角色！",
        enterRoleDisplay:"请输入角色显示名！",
        enterOrderNumber:"请输入序号！",
        mailSendingFailed:"邮件发送失败！",
        mailSendingSuccessfully:"邮件发送成功！",
        downloadImg:"下载图片",
        downloadExcel:"下载Excel",
    },
    
    desc:{
        downloadDataDetails:"下载前后30秒数据明细",
        isConnectedAsset: "是否已连接",
        isRegisteredAsset: "是否已注册",
        withinTheContractWarrantyPeriod:"保内",
        outsideTheContractWarrantyPeriod:"保外",
        locationAddress: "定位地址",
        recent1D: "最近一天",
        recent3D: "最近三天",
        recent1W: "最近一周",
        recent1M: "最近一个月",
        recentThreeM: "最近三个月",
        recent3M: "最近3个月",
        t3To6M: "3到6个月",
        t6To12M: "6到12个月",
        t1YAgo: "1年以前",
        faultSnapshot: "故障快照",
        timestamp:"时间戳",
        SE列表: "服务工程师",
        SSE列表: "销售工程师",
        Dealer列表: "经销商",
        SE: "服务工程师",
        SSE: "销售工程师",
        Dealer: "经销商",
        onWarning: "告警",
        onTrip: "故障",
        "codeAlarm":"（代码",
        "rightkuohao": "）",
        "chinese": "中文",
        "english": "英文",
        "客户": "客户",
        "设备": "设备",
        "客户中心": "客户中心",
        "客户列表": "客户列表",
        "设备列表": "设备列表",
        "客户中心列表": "客户中心列表",
        registrationNumber:"已注册数量",
        insightType:"Insight 类型",
        screeningTime:"筛选时间",
        lastReplaceTime:"上次更换日",
        beforRunningTime:"上次更换运行时长",
        replaceTime:"推荐更换周期",

        noPicture:"暂无图片",
        customerHotline:"客户热线",
        customerHotlineEn:"Customer hotline",
        domesticHotline:"国内热线",
        globalHotline:"全球热线",
        exportFailed:"导出失败",
        lastmonth:"上月",
        monthOnMonth:"较",
        monthUpdate:"每月更新",
        current:"当前",
        userName:"用户名",
        name:"菜单名",
        roleName:"角色",
        displayName:"角色名",
        description:"描述",
        all:"全部",
        select:"请选择",
        enterAdminPwd:"请输入当前账号密码",
        code:"编号",
        NO:"ID",
        automaticallyCreation:"创建完成后自动生成",
        autogeneration:"自动生成",
        password:"密码",
        page:"一级菜单",
        childPage:"二级菜单",
        permissions:"权限",
        none:"无",
        yes:"是",
        no:"否",
        是:"是",
        否:"否",
        isEnable:"授权可用",
        parentMenu:"一级菜单",
        icon:"图标",
        describe:"描述",
        sort:"排序",
        keyword:"关键词",
        dsn:"设备序列号",
        gsn:"网关序列号",
        ccn:"控制器版本号",
        customerName:"客户名称",
        projectName:"项目名称",
        straightPipe:"直管",
        dealer:"经销商",
        serviceDistributor:"服务经销商",
        middleman:"中间商",
        other:"其他",
        直管:"直管",
        直销:"直管",
        经销商:"经销商",
        服务经销商:"服务经销商",
        中间商:"中间商",
        其他:"其他",
        airCompressionStation:"空压站名称",
        gatewaySN:"网关SN号",
        airCompressorSN:"产品SN号",
        gatewayBindingStatus:"绑定状态",
        signalStrength:"信号强度",
        BaudRate:"波特率",

        ServiceOrderCode:"服务订单号",
        serviceItem:"服务项",
        pmc:"定期保养检查清单",
        serviceComparison:"服务对照",
        serviceDetails:"服务明细",
        workExtent:"工作范围",
        routineMaintenance2000:"2000小时例行保养",
        routineMaintenance4000:"4000小时例行保养",
        routineMaintenance8000:"8000小时例行保养",
        routineMaintenance16000:"16000小时例行保养",
        routineMaintenance16000More:"16000小时以上例行保养",

        ccnDatabits:"数据位",
        ccnStopbit:"停止位",
        ccnCheckbit:"校验位",
        ccnCom:"串口",
        IP:"IP地址",
        port:"端口号",
        oddNumber:"奇",
        evenNumber:"偶",
        customerList:"客户列表",
        customer:"客户",
        roapCustomerCode:"Roap客户代码",
        equipment:"设备",
        customerCenter: "客户中心",
        null: "",
        authList: "权限列表",
        project:"项目",
        managerPwd:"管理员密码",
        department:"部门",
        dealername:"经销商名称",
        state:"状态",
        normal:"正常",
        stop:"停止",
        正常:"正常",
        停止:"停止",
        changePaw:"修改密码",
        LogOut:"退出",
        AirCompressorFailureRate:"产品故障率",
        TotalRegistratedNumber:"注册总数",
        OnlineNumber:"在线数",
        DisconnectedNumber:"未连接",
        High:"高",
        Low:"低",
        TripNumber:"故障台数",
        AirCompressorUtilizationRate :"产品利用率",
        WarningNumber :"警告台数",
        NumberforService :"待服务数",
        NumberofServiceOverdue:"过期未服务数",
        ServiceLossRate :"服务丢失率",
        RecentDaysAirCompressorRegistrationTrend :"产品注册率",
        AirCompressorsDailyRegistrationNumber:"产品日注册总数",
        UtilizationRateofVariousIndustries :"行业利用率",
        DeviceRate:"上月利用率",
        recent12loadingRate:"最近12个月加载率",
        sendOutNumber:"已发货",
        relieveBindCount:"解绑数",
        goBack:"返回上一级",
        tai:"台",
        Industryutilizationrate:"产品行业利用率",
        useratio:"利用率",
        gross:"总量",
        Aircompressorunit:"产品总台量",
        food:"食品",
        publicutilities:"公共事业",
        MiningAuxiliaryActivity:"开采辅助活动",
        miningindustry:"其他采矿业(除油气)",
        oilandgasexploitation:"油气开采",
        run:"运行",
        Run:"运行",
        stop:"停机",
        Stop:"停机",
        load:"加载",
        Load:"加载",
        Unload:"卸载",
        "No data":"No Data",
        stopAndError:"停机 故障",
        stopAndErrorAndWarn:"停机 故障",
        stopAndWarn:"停机 警告",
        loadAndWarn:"加载 警告",
        loadAndTrip:"加载 故障",
        UnloadAndWarn:"卸载 警告",
        //Xe-145F状态
        运行:"运行",
        停机:"停机",
        加载:"加载",
        卸载:"卸载",
        警告:"警告",
        故障:"故障",
        "停机 故障":"停机 故障",
        "停机 故障 警告":"停机 故障",
        "停机 警告":"停机 警告",
        "加载 警告":"加载 警告",
        "卸载 警告":"卸载 警告",
        "已卸载 警告":"卸载 警告",
        "Stop Trip":"停机 故障",
        "Stop Trip Warning":"停机 故障",
        "Stop Warning":"停机 警告",
        "Load Warning":"加载 警告",
        "Unload Warning":"卸载 警告",
        "Unloaded Warning":"卸载 警告",
        //LR(高压活塞机)Package Status(机组状态) 0、2-8，后端 v2 回的是英文，这里翻中文
        //（缺词条时前端会退回显示后端原文，不会报错）
        "Ready / Stopped":"就绪 / 已停机",
        "Starting":"启动中",
        "Unloaded Run":"空载运行",
        "HP Half Load":"高压半载运行",
        "HP Full Load":"高压满载运行",
        "Fault":"故障",
        "Auto Standby":"自动待机",
        "Stopping":"停机中",
        等待: "等待",
        惯性运转: "惯性运转",
        启动: "启动",
        未准备好: "未准备好",
        准备好: "准备好",
        喘振卸载: "喘振卸载",
        自动双卸载: "自动双卸载",
        卸载中: "卸载中",
        已卸载: "已卸载",
        最小负荷: "最小负荷",
        最大负荷: "最大负荷",
        加载中: "加载中",
        满负荷: "满负荷",
        模拟输入故障: "模拟输入故障",
        空压机综合跳闸: "产品综合跳闸",
        空压机综合报警: "产品综合报警",
        //MU状态
        尚未做好启动准备: "尚未做好启动准备",
        准备启动: "准备启动",
        正在启动: "正在启动",
        加速: "加速",
        运行: "运行",
        正在停止: "正在停止",
        惯性惰转: "惯性惰转",
        "运行/已报警": "运行/已报警",
        已加载: "已加载",//两个都有
        已卸载: "已卸载",//两个都有
        正在加载: "正在加载",
        正在卸载: "正在卸载",

        offline:"脱机",

        stoping:"停止",

        pmPureLabor:"定期保养",
        oneTimePM:"一次性保养",
        extendWarranty:"延长保修",
        factoryWarranty:"工厂保内",
        PACKAGECARE:"PACKAGECARE",
        "PLANNEDCARE（有延保）":"PLANNEDCARE（有延保）",
        "PLANNEDCARE（无延保）":"PLANNEDCARE（无延保）",
        PARTSCARE:"PARTSCARE",
        "CARE（定期保养-纯服务）":"CARE（定期保养-纯服务）",
        "CARE（延长保修）":"CARE（延长保修）",
        "CARE（一次保养）":"CARE（一次保养）",
        "CARE（清洗服务）":"CARE（清洗服务）",
        "Ultimate CARE Pro(旗舰版)":"Ultimate CARE Pro(旗舰版)",
        "Ultimate CARE Select(精选版)":"Ultimate CARE Select(精选版)",
        "Ultimate CARE Lite(精简版)":"Ultimate CARE Lite(精简版)",
        "Ultimate CARE Labor(纯人工)":"Ultimate CARE Labor(纯人工)",
        "AOF/EMC":"AOF/EMC",
        "AIRCARE（定期保养）":"AIRCARE（定期保养）",
        "AIRCARE（定制保障）":"AIRCARE（定制保障）",
        "AIRCARE（全面保障）":"AIRCARE（全面保障）",
        "SELECTCARE（选项1）":"SELECTCARE（选项1）",
        "SELECTCARE（选项2）":"SELECTCARE（选项2）",
        "SELECTCARE（选项3）":"SELECTCARE（选项3）",

        hours:"小时",
        simpleHours:" 小时",
        connected:"已连接",
        waitService:"待服务",
        unService:"过期未服务",
        online:"在线",
        energyConsumption:"能耗",
        flux:"流量",
        customerHotline:"客户热线",
        max:"最大",
        min:"最小",
        average:"平均值",
        refresh:"刷新",
        noData:"暂无数据",
        beingDevelop:'正在开发中',
        comeSoon:'敬请期待',
        developInfo:"非常抱歉，您访问的此页面正在开发中",
        healthDegree:"产品健康度",
        allInCost:"总费用",
        AverageMonthly:"每月平均",
        yuan:"元",
        customerArea:"客户区域",
        NotAbletoConnect:"无法连接的单元",
        SendOutCount:"已发货",
        shipped_penddingConnect:"已发货-未连接",
        wait_bind:"等待注册",
        already_bind:"已注册",
        Connected_Offline:"离线",//"已连接 - 脱机",
        Connected_Active:"在线",//"已连接 - 在线",
        UtilizationRate:"利用率",
        MachinesDueService:"待服务",//"待服务台数",
        MachinePastDueService:"服务过期",//"过期未服务台数",
        ActiveCriticalAlarmsTrips:"运行机组重大报警/跳车",
        EstimatedPowerConsumption:"预测能耗",
        Insight3:"Sales lead _ High Separator Element DP",
        Insight4:"Sales lead _ High Oil Filter DP",
        Insight5:"Sales lead _ High Air Filter DP",
        EstimatedFlow:"预测流量",
        RetroFit:"现场安装",
        FactoryFit:"工厂安装",
        RetroFitBind:"现场安装已注册",
        FactoryFitBind:"工厂安装已注册",
        FactoryFitWaitBind:"工厂安装等待注册",
        RetroFitWaitBind:"现场安装等待注册",
        RetroFitOffLine:"现场安装离线",
        FactoryFitOffline:"工厂安装离线",
        RetroFitOnLine:"现场安装在线",
        FactoryFitOnline:"工厂安装在线",
        IndependentGSNCount:"独立网关",
        IndependentGSNBindCount:"独立网关已注册",
        IndependentGSNWaitBindCount:"独立网关等待注册",
        IndependentGSNOnLineCount:"独立网关在线",
        IndependentGSNOffLineCount:"独立网关离线",
        IntegratedGSNCount:"集成网关",
        IntegratedGSNBindCount:"集成网关已注册",
        IntegratedGSNWaitBindCount:"集成网关等待注册",
        IntegratedGSNOnLineCount:"集成网关在线",
        IntegratedGSNOffLineCount:"集成网关离线",

        IoTGSMCosts:"上月IoT移动通讯费用(不含初装费用)",
        ForecastService:"服务预测",
        Warranty:"保内",
        OfflineNormal:"脱机 - 主动脱机",
        OfflineFault:"脱机 - 故障脱机",
        monthly:'月度',
        quarterly:'季度',
        annual:'年度',
        operateUser:'操作人',
        loginUser:'登陆人',
        pacCcnImportDealed:"导入MU点表",
        pacCcnImportController:"导入控制器csv文件",
        pacCcnImportTemplate:"控制器导入模板",
        pacCcnDealImportTemplate:"MU点表模板",
        exportTemplate:"导入模板",
        exportExpertAdviceTemplate:"专家建议导入模板",
        exportTemplateServiceType:"服务类型导入模板",
        lost:"已丢失",
        notlost:"未丢失",
        pushed:"已推送",
        notPush:"未推送",
        maintained:"已保养",
        notMaintained:"未保养",
        expireMaintain:"过期未服务",
        utilizationtrend:"最近12月利用率",
        BusinessMessage:'商业信息',
        factory:'工厂',
        headquarters:'总部',
        isContainWJ:"包含吴江工厂",
        saveAsImage:"保存为图片",
        brandSwitch:"品牌切换",
        languageSwitch:"语言切换",
        curMonthReal:"本月实时",
        weekLy:"每周",
        IoTInsight:"IoT洞察",
        unboundCount:"解绑数量",
        PasswordModifiedSuccessfully:"密码修改成功！",
        
        alarmAbstract:"告警摘要",
        customerAssent:"客户资产",
        alarmTime:"告警时间",
        serviceRecord:"服务记录",
        estimatedServiceDate:"预计服务日期",
        tendency:"运行趋势",
        loadingRate:"加载率",
        DailyRunningTime:"每日运行时间",
        alarmInfo:"告警信息",
        possibleCauseOfFailure:"可能故障原因",
        solution:"解决方法",
        viewDetail:"查看详细",
        compressorNumber:"产品编号",
        downloadFileNotFound:"未找到下载文件",
        detailedDataNotFound:"未找到详细数据",
        ssoAccount:"SSO 账号",
        systemAccount:"系统账号",
        "accountVerificationSuccessful": "账号验证成功，跳转中...",
        "accountVerificationFail":"账号验证失败，",
        "returnLoginPageSecond": "秒后返回登录页面",
        "useIRAccountLogin": "使用IR账号登录",
        "equipmentRegistrationList": "设备登记列表",
        "确定获取定位信息吗": "确定获取定位信息吗",
        "noAccess": "无权限！",
        "sorry": "非常抱歉！",
        "cantuse": "您没有权限使用此功能，请联系系统管理员进行权限升级",
        "未找到告警监控数据！":"未找到告警监控数据！",
        "returnLogin":"返回登录页",
        "未找到监控数据":"未找到监控数据！"
    },
    title: {
        expertAdvice:"专家建议",
        forgetPwd:"忘记密码？",
        ssologin:"SSO登录",
        title:"产品物联网管理平台",
        //ccnFull: "控制器软件CCN号",
        confirmDelete: "确定删除吗?",
        controllCcn: "控制器软件CCN号",
        ccnVersion: "CCN版本",
        controllerModel:"控制器型号",
        ccnCreateTime: "版本生成时间",
        ccnModifyTime: "最近更新时间",
        creator:"创建人",
        ccnDirectory: "点表总目录",
        serialNumber: "序号",
        operate: "操作",
        addCcnTitle: "新增控制器软件CCN号",
        editCcnTitle: "修改控制器软件CCN号",
        upGradeCcnTitle:"升级控制器软件CCN版本",
        ccnTable: "点表",
        ccnErrorInfo: "报错信息",
        ccnExpertAdviceInfo: "专家建议",
        monitorIndex: "监控指标",
        monitorDesc: "指标描述",
        monitorDataType:"类型",
        monitorUnit:"单位",
        monitorType:"回传类型",
        pacCcnSetting:"点表设置",
        pacControllerType:"控制器型号",
        monitorAddress:"地址值",
        account:"账号",
        emailAddress:"邮箱地址",
        mobilePhone:"联系电话",
        resetPassword:"重置密码",
        relieveLock:"解除锁定",
        relieveLockSuccess:"解除锁定成功",
        tips:"提示",
        editUser:"编辑用户",
        selectRole:"选择角色",
        newPassword:"新密码",
        chooseIcon:"选择图标",
        isLocked:"是否锁定",
        isActive:'是否激活',
        country:"国家/地区",
        region:"大区",
        customerCenter:"客户中心",
        customerTypePac:"客户类型",
        liaison:"联络处",
        chengcity:"城市",
        customerCode:"客户编码",
        managementUnit:"管理单位名称",
        managementCode:"管理单位代码",
        companyType:"单位性质",
        province:"省",
        provinceFen:"省份",
        city:"市",
        address:"地址",
        industry:"行业",
        longitude:"经度",
        latitude:"纬度",
        airCompressionStationAddress:"空压站地址",
        managementAirCompressionStation:"空压站管理",
        productLine:"产品线",
        productCategories:"产品大类",
        smallClassProduct:"产品小类",
        machineType:"机型",
        productFamily:"产品族",
        productFamilyName:"产品族名称",
        power:"功率",
        dischargePressure:"排气压力",
        coolingMode:"冷却方式",
        imageName: "图片名称",
        colon:"：",
        modelImage:"机型图片",
        addProductLine:"新增产品类型",
        addMachineType:"新增机型",
        updateProductLine:"修改产品线",
        updateProductCategories:"修改产品大类",
        updateSmallClassProduct:"修改产品小类",
        updateMachineType:"修改机型",
        isBinding:"绑定状态",
        serviceStatus:"服务状态",
        registerTime:"绑定时间",
        lastBeatTime:"最后在线时间",
        isRegister:"注册状态",
        UtilizationRate:"前一天利用率",
        GetConnecTime:"获取连接字符串时间",
        AwsThingCreateTime:"注册AWS时间",
        releaseTime:"点表下发时间",
        GatewayVersion:"网关软件版本",
        GatewaySN:"网关SN",
        GatewayFirmwareId:"网关固件ID",
        GatewayFirmwareVersion:"网关固件版本",
        SIMNumber:"SIM卡号",
        SIMCount:"张",
        SIMLatitude:"SIM卡经纬度",
        GatewayLocation:"网关定位",
        GatewayNetworkType:"网关网络类型",
        airCompressorRegister:"产品登记",
        updateAirCompressor:"产品修改",
        airCompressorType:"产品型号",
        airCompressorService:"产品服务类型",
        controlsCCN:"控制器软件CCN号",
        controlsSN:"控制器硬件SN号",

        RelieveCcn:"解绑Ccn号",
        RelieveCcnVersion:"解绑Ccn版本号",
        RelieveGsn:"解绑网关SN号",
        FinalRelieveTime:"最后解绑时间",

        accountType:"账号类型",
        accountName:"账号名",
        tenantAccount:"租户账号",
        dealercode:"经销商代码",
        agencystate:"当前状态",
        errorCode:"故障代码",
        errorDescription:"故障描述",
        errorType:"故障类型",
        AddPointTableData:"新增点表数据",
        EditPointTableData:"编辑点表数据",
        addArea:"新增地区",
        Datefrom:"日期",
        to:"至",
        beginDate:"开始日期",
        endDate:"结束日期",
        beginMonth:"开始月份",
        endMonth:"结束月份",
        warning:"告警",
        trip:"故障",
        alarmType:"告警类型",
        alarmStatus:"处理状态",
        alarmTime:"告警时间",
        alarmContent:"告警内容",
        alarmSta:"告警状态",
        alarmCode:"告警代码",
        AlarmDetailInformation:"告警详细内容",
        relieveTime:"解除时间",
        expertAdvice:"专家建议",
        error:"未解除",
        relieve:"已解除",
        area:"大区",
        readStatus:"读取状态",
        read:"已读",
        unread:"未读",
        AddAlarmReceiver:"新增告警接收人",
        AlarmReceiver:"告警接收人",
        authType:"权限类型",
        creationTime: "创建时间",
        AirCompressorBindNumber:"绑定台数",
        AirCompressorAlarmNumber:"产品报警台数",
        AirCompressorStatus:"产品状态",
        AirCompressorTotalNumber:"产品总数",
        AirCompressorBindTotalNumber:"已绑定产品总数",
        asOf:"截止至",

        gatewaystatus:"网关状态",
        RunningTime:"运行时长",
        DischargePressure:"机组排气压力",
        RatedPressure:"额定压力",
        CurrentStatus:"当前状态",
        LoadedTime:"加载时长",
        UnloadedTime:"未加载时长",
        DischargeTemperature:"主机排气温度",
        DriverMotorCurrent:"主机变频器电机电流",
        MotorCurrent:"电机电流",
        TargetPressure:"目标压力",
        VsdMotorSpeed:"主机变频器电机转速",
        SystemPressure:"系统压力",
        Stage1Pressure:"一级排气压力",
        Stage1Virbation:"一级振动",
        Stage1Temperature:"一级排气温度",
        dischargePressurePac:"排气压力",
        Stage2InletTemp:"二级进气温度",

        MonitoringDate:"监控日期",
        MonitoringParameters:"监控参数",
        selectFive:"请选择，最多可选五项指标",
        selectTwenty:"请选择，最多可选二十项指标",
        realtimemonitoring:"实时监控",
        historymonitoring:"历史监控",
        tableDetail:"点表详细数据",
        monitortableDetail:"监控详细数据",
        deviceInsight:"电机振动监控",
        minutes:"分钟",
        Index:"指标",
        number:"数值",
        time:"时间",
        chooseDate:"选择日期",
        CooperationStatus:"合作状态",
        enterOriginalPwd:"输入原密码",
        setNewPwd:"设置新密码",
        setNewPwdAgain:"再次输入新密码",

        viewMonitor:"查看监控",
        warnMonitor:"故障监控",

        logType:"日志类型",
        logTitle:"日志标题",
        logContent:"日志内容",
        errorMsg:"错误信息",
        remark:"备注",
        customerType:"客户性质",
        monitorDataDetail:"监控数据详情",
        ccnDataDetail:"点表数据详情",
        creatTime:"创建时间",
        updateTime:"更新时间",
        loginTime:'登录时间',
        batchImportCustomer:"批量导入客户",
        batchImportGetway:"批量导入网关",
        batchImportSim:"批量导入Sim卡",
        batchImportServiceHistory:"导入服务记录",
        batchImportModel:"批量导入机型",
        Imgtitle:"标题",
        Image:"图片",
        mainImage:"主图片",
        msgContent:"信息内容",
        editMsg:"修改商业推送信息",
        checkMsg:"查看商业推送信息",

        Alarm_View: "告警",
        maintainTab: "维修保养记录",
        Bound:"已绑定",
        Unbound:"未绑定",
        Registered:'已注册',
        Unregistered:'未注册',
        proportion:"占比",
        unutilized:"未利用",
        SIMCardCost:"SIM卡费用",
        AWSCharges:"AWS费用",
        SIMAWS:"最近3个月SIM卡费用和AWS费用统计",
        PerUnitMonth:'平均单台每月',
        LastMonth:'上月费用',

        fault:"故障产品台数",
        totalNumber:"总台数",
        faultRate:"健康度",
        modelRatio:"各型号总数占比",
        modelFaultRate:"各型号故障率排名",
        industryRatio:"各行业总数占比",
        industryFaultRate:"各行业故障率排名",
        regionRatio:"各区域总数占比",
        regionFaultRate:"各区域故障率排名",
        customCenterRatio:"各客户中心总数占比",
        customCenterFaultRate:"各客户中心故障率排名",
        ModelUtilizationRate:"各型号利用率排行",
        IndustryUtilizationRate:"各行业利用率排行",
        IndustryUtilizationRateTop10:"各行业利用率（前10）",
        overallUtilizationTrendChart:"整体利用率趋势",
        IndustryUtilizationRateTop102:"各行业利用率排行（前10）",
        RegionUtilizationRate:"各区域利用率排行",
        CustomCenterUtilizationRate:"各客户中心利用率排行（前10）",

        //预测维护页面
        runningTime:"运行时间",
        pushCycleMaintain:"推送例行保养",
        alreadyMaintained:"已服务",
        maintainLose:"服务丢失",
        maintainType:"小时例行保养",
        maintainTypeDesc:"服务类型",
        editDate:"编辑日期",
        sendDate:"发布日期",
        pushUser:"发布人",
        serviceConfirmed:"已服务确认",
        serviceHistory:"服务记录",

        ccnExportTitle:"点表导出",
        gtherExportTitle:"导出",
        InformationPush:"信息推送",
        UploadFrequency: "上传频率(s)",

        brand:"品牌",
        brandName:"品牌名称",
        brandCode:"品牌编码",
        brandDisplay:"品牌",
        presetDesc:"控制器型号",
        offset:"偏移量",
        scale:"缩放量",
        default:"是否默认",
        isShowMonitor:"是否监控显示",
        showMonitorOrder:"监控显示排序",
        "unbindDate":"解绑日期",
        "点表批量导入":"点表批量导入",
        "专家建议导入": "专家建议导入"
    },
    gatewayState:{
        "正常":"正常",
        "在线":"在线",
        "警告":"警告",
        "未连接":"未连接",
        "脱机":"脱机",
        "离线":"离线"
    },
    el: {
        colorpicker: {
            confirm: '确定',
            clear: '清空'
        },
        datepicker: {
            now: '此刻',
            today: '今天',
            cancel: '取消',
            clear: '清空',
            confirm: '确定',
            selectDate: '选择日期',
            selectTime: '选择时间',
            startDate: '开始日期',
            startTime: '开始时间',
            endDate: '结束日期',
            endTime: '结束时间',
            prevYear: '前一年',
            nextYear: '后一年',
            prevMonth: '上个月',
            nextMonth: '下个月',
            year: '年',
            month1: '1 月',
            month2: '2 月',
            month3: '3 月',
            month4: '4 月',
            month5: '5 月',
            month6: '6 月',
            month7: '7 月',
            month8: '8 月',
            month9: '9 月',
            month10: '10 月',
            month11: '11 月',
            month12: '12 月',
            // week: '周次',
            weeks: {
                sun: '日',
                mon: '一',
                tue: '二',
                wed: '三',
                thu: '四',
                fri: '五',
                sat: '六'
            },
            months: {
                jan: '一月',
                feb: '二月',
                mar: '三月',
                apr: '四月',
                may: '五月',
                jun: '六月',
                jul: '七月',
                aug: '八月',
                sep: '九月',
                oct: '十月',
                nov: '十一月',
                dec: '十二月'
            }
        },
        select: {
            loading: '加载中',
            noMatch: '无匹配数据',
            noData: '无数据',
            placeholder: '请选择'
        },
        cascader: {
            noMatch: '无匹配数据',
            loading: '加载中',
            placeholder: '请选择',
            noData: '暂无数据'
        },
        pagination: {
            goto: '前往',
            pagesize: '条/页',
            total: '共 {total} 条',
            pageClassifier: '页'
        },
        messagebox: {
            title: '提示',
            confirm: '确定',
            cancel: '取消',
            error: '输入的数据不合法!'
        },
        upload: {
            deleteTip: '按 delete 键可删除',
            delete: '删除',
            preview: '查看图片',
            continue: '继续上传'
        },
        table: {
            emptyText: '暂无数据',
            confirmFilter: '筛选',
            resetFilter: '重置',
            clearFilter: '全部',
            sumText: '合计'
        },
        tree: {
            emptyText: '暂无数据'
        },
        transfer: {
            noMatch: '无匹配数据',
            noData: '无数据',
            titles: ['列表 1', '列表 2'],
            filterPlaceholder: '请输入搜索内容',
            noCheckedFormat: '共 {total} 项',
            hasCheckedFormat: '已选 {checked}/{total} 项'
        },
        image: {
            error: '加载失败'
        },
        pageHeader: {
            title: '返回'
        }
    },
    menu: {
        Home_View: "首页",
        MultiBrand_View: "全局仪表盘",
        SystemManagement_View: "系统管理",
        CustomerManagement_View: "客户管理",
        DeviceManagement_View: "设备管理",
        DeviceMonitorManagement_View: "设备监控",
        AlarmManagement_View: "告警管理",
        User_View: "用户管理",
        Role_View: "角色管理",
        Menu_View: "菜单管理",
        Region_View: "Rotary客户区域管理",
        PACRegion_View:"PAC客户区域管理",
        BVRegion_View:"BV客户区域管理",
        Customer_View: "产品客户信息管理",
        DeviceModel_View: "产品型号管理",
        Ccn_View: "Rotary点表管理",
        PacCcn_View: "PAC点表管理",        
        BvCcn_View: "BV点表管理",
        LrCcn_View: "LR点表管理",
        LrCcn: "LR点表管理",
        EnduranceCcn_View: "耐久性测试点表管理",
        Gateway_View: "产品网关管理",
        Device_View: "产品设备登记",
        Station_View: "产品客户站房管理",
        Logger_View:"操作日志",
        CustomerAccount_View:"产品客户账号管理",
        DeviceMonitor_View: "产品监控列表",
        Alarm_View: "告警查询",
        AlarmRules_View: "告警规则",
        AlarmPushRules_View:"告警推送SFA规则",
        Agency_View:"产品客户经销商管理",
        DeviceAnalysis_View:"设备分析",
        PredictiveMaintenance_View:"预测维护",
        RoutineMaintenance_View:"例行保养",
        DeviceStatistics_View:"设备统计",
        AirCompressorStatistical_View:"产品故障统计",
        GatewayStatusStatistics_View:"网关统计",
        AirCompressorKPIIndex_View: "产品KPI",
        InstallKPIIndex_View: "产品安装KPI",
        InstallDashboard_View: "实时安装报表",
        AlarmProcess_View:"告警处理",
        MobileSIMManagement_View :"移动网卡管理",
        UnicomManagement_View:"联通网卡管理",
        DeviceImage_View:"产品图片管理",
        BusinessInfoPush_View:"商业信息",
        BusinessInfoPushList_View:"商业信息推送列表",
        StatisticalForm:"统计报表",
        StationInfo:"站内信息",
        MaintenancePlan:"例行保养",
        UtilizationStatistical_View:"产品利用率统计",
        UtilizationStatPAC_View:"PAC利用率统计",
        UtilizationStatNew_View:"产品利用率统计（新）",
        LoadedRateStatistics_View:"产品加卸载统计",
        EmcPotentialCustomer_View:"EMC潜在客户",
        Ota_View:"设备固件包管理",
        OtaUpgrade_View:"OTA管理",
        LoginLogger_View: "登录日志",
        Brand_View:"品牌管理",
        RunningTime_View:"运行时间报表",
        ThirdMonitor_View:"设备监控",
        Unbound_View:"解绑报表",
        PMReport_View:"PM报表",
        MisureReport_View:"误用报表",
        CustomerReport_View:"客户摘要报表",
        PartReport_View:"零件查找报告",
        AssetReport_View:"资产摘要报表",
        AlarmReport_View:"报警摘要报表",
        InstallReport_View:"安装报表",
        PasswordLog_View:"密码修改日志",
        MaintainRecord_View:"服务记录",
        GatherUnit_View:"PAC单位转换公式",
        Endurance_View:"耐久性测试设备登记",
        EnduranceManagement_View:"耐久性测试",
        AIDiagnosis_View:"电机振动AI诊断",
    },
    acronym:{
        airCompressorSN:"产品SN号",
        gatewaySN:"网关SN号",
        gatewayBindingStatus:"绑定状态",
        ccn:"软件CCN号",
        gatewaystatus:"网关状态",
        serviceType:"服务类型",
        serviceStatus:"服务状态",
        installMethod:"安装方式",
        fieldInstallation:"现场安装",
        plantErection:"工厂安装",
        factory:"工厂安装",
        scene:"现场安装",
        null:"",
        undefined:"",
        "":"",
    },
    sim:{
        TotalSIMCards:'SIM卡总数',
        CostOfLastMonth:'上月费用',
        sheet:'张',
        yuan:'元',
        month:'月份',
        DataThisMonth:'本月数据用量',
        SimDetails:'SIM明细',
        SIMActivationStatus:'SIM卡激活状态',
        ExpensesInRecentSixMonths:'近6个月费用情况',
        TrafficUsageInRecentSevendays:'近7天流量使用情况',
        TrafficUsageInRecentSixMonths:'近6个月流量使用情况',
        cost:'费用',
        flow:'流量',
        ClickToViewDetails:'点击查看明细',
        Activated:"已激活 ",
        NotActive:"待激活 ",
        Shutdown:'已停机 ',
        Testable:'可测试',
        Stock:'库存',
        PreCancellation:'预销户',
        other:"其他: ",
        simNo:'SIM卡号',
        simStatus:'SIM卡状态',
        bindSnNo:'绑定产品SN号',
        gatewayNo:"网关",
        monthlyFlow:"月流量",
        monthlyFee:'月费用'
    },
    unicom:{
        "testable":"可测试",
        "activatable":"可激活",
        "activated":"已激活",
        "deactivated":"已停用",
        "invalid":"已失效",
        "cleared":"已清除",
        "replaced":"已更换",
        "stock":"库存",
        "start":"开始",
    },

    lable:{
        BusinessPush:'站内通知',
        NoticPush:'APP 通知',
        EmailPush:'邮件通知',
    },
    ota:{
        selectAll:"请选择",
        online:"在线",
        offline:"离线",
        warning:"告警",
        remark:"备注",        
        controllCcn: "软件CCN号",
        ccnVersion: "点表版本",
        FirmwareUpgrade:'升级任务',
        FirmwareUpgradeName:'升级任务名称',
        FirmwareSelect:'软件',
        upgradeRemark:'升级备注',
        FirmwareUpload:'设备软件上传',
        FirmwareName:'设备软件名称',
        DeviceModel:'机型',
        VersionNumber:'固件版本号',
        engineerVersionNo:'工程版本号',
        upgradeDesc:'更新说明',
        Upload:'点击上传',
        UploadFile:'上传OTA文件',
        tipsMessage1:'最多只可上传 1 个文件!',
        tipsMessage2:'文件格式不正确!',
        create:'新增软件信息',
        edit:'编辑软件信息',
        createUpgrade:'新增升级任务',
        editUpgrade:'编辑升级任务',
        cofirmDelete:'确认移除',
        geteWayName:'网关名称',
        oldVersion:'现固件版本',
        newVersion:'新固件版本',
        firnwarUpgrade:'固件版本升级',
        selectVersion:'请选择固件版本',
        upgradeSuccess:"升级指令已创建，正在下发中",
        upgradeDeviceSaveSuccess:"升级设备设置成功",
        upgradePushFileTitle:"下发升级包",        
        upgradePushFileTime:"下发升级包时间",    
        upgradeDownLoadFileTime:"下载升级包时间",
        upgradeScheduledTime:"定时升级时间",
        upgradePushInstallTime:"下发升级命令时间",
        upgradePushInstallTitle:"下发升级命令",
        upgradeFileSending:"升级包下发传输成功",
        upgradeInstallSending:"下发升级命令成功",
        confirmPushUpgradeInstall:"确定下发升级命令吗？",
        confirmPushFile:"确定下发升级包吗？",
        deviceType:"设备类型",
        deviceBrand:"设备厂商",
        gateway:"网关",
        controller:"控制器",
        upgradeCompleted:"升级完成",
        upgradeSucceeded:"升级成功",
        upgradeFailed:"升级失败",
        upgrading:"升级中",
        batchUpgrade:"设置升级设备",
        upgradeResult:"升级结果",
        airCompressor:"空压机",
        releaseTime:"下发时间",
        upgradeStatus:"升级状态",
        flowStatus:"流程状态",
        completionTime:"完成时间",
        notUpgraded:"未升级",
        issued:"已下发",
        RegularUpgrade:"定时升级",
        TotalUpgrades:"升级总数：",
        NumberOfSuccesses:"成功数量：",
        NumberOfFailures:"失败数量：",
        "手动升级成功":"手动升级成功",
        "已安装升级包":"已安装升级包",
        "已接收安装命令":"已接收安装命令",
        "已下发安装命令":"已下发安装命令",
        "已下载升级包":"已下载升级包",
        "已下发升级包":"已下发升级包",
        "未升级":"未升级",
        "下载失败":"下载失败",
        "接收命令失败":"接收命令失败",
        "安装失败":"安装失败",
        "手动升级失败":"手动升级失败",
    },
    forgetpws:{
        Forgetthepassword:'忘记密码?',
        Fillinemailaddress:'填写邮箱地址',
        FillRightEmail:'填写账号或预留的邮箱地址，发送验证码',
        CodeReceived:'填写邮件中收到的验证码，重新设置密码',
        complete:'完成',
        Verificationsuccessful:'验证成功，完成密码重置',
        inputEmail:'请输入账号或邮箱地址',
        next:"下一步，发送验证码至账号邮箱",
        VerificationCode:'验证码',
        ResendCode:'重新发送验证码',
        ResendCodeTips:'验证码已发送至账号邮箱内，请注意查收，如未收到，请点击重新发送验证码。',
        newpsw:'请输入新密码',
        newpsw1:'再次输入新密码',
        newpsw3:'请再次输入新密码',
        confirmbtn:'确认',
        setclick:'设置成功！点击',
        loginAgin:' ，重新进行登录！',
        IllegalEmail:'邮箱地址不合法',
        frequently:'验证码发送频繁',
        InvalidCode:'验证码不正确',
        expiredCode:'验证码已过期',
        existEmail:'邮箱地址不存在',
        accountOrEmail:"账号/邮箱",
    },
    dataAuth:{
        DataPermissions:"数据权限",
        PermissionSetting:"数据权限设置",
        NoRestrictions:"不限制",
        SwitchingTime:"切换时间",
        LastMonth:"最近一个月",
        LastThreeMonths:"最近三个月",
        LastSixMonths:"最近六个月",
        LastYear:"最近一年",
    },
    RunningTIme:{
        FileName:"文件名称",
        Name:"名称",
        Type:"类型",
        LastModify:"上次修改时间",
        Size:"大小",
        StorageClass:"存储类",
        Download:"下载文件",
        DownloadReport:"下载检查报告",
        reportType:"报表类型",
        custReport:"客户报表",
        viewReport:"View Report",
        reportDate:"报表时间"
    },
    opeateType:{
        create:"账号创建",
        edit:"密码修改",
        reset:"管理员重置密码",
        forget:"用户重置密码"
    },
    logType:{
        "修改":"修改",
        "创建":"创建",
        "网关绑定":"网关绑定",
        "删除":"删除",
        "网关解绑":"网关解绑",
        "错误":"错误",
        "其它":"其它"
    },
    userType:{
        backStage:"后台管理",
        cutomer:"客户",
        agency:"经销商"
    },
    pwdTips:{
        "密码长度必须大于等于8位！":"密码长度必须大于等于8位！",
        "密码至少包含大写字母、小写字母、数字、符号中任意三个！":"The password must contain at least three uppercase letters, lowercase letters, numbers and symbols!",
        "新密码不能包含账号名称或者全名！":"新密码不能包含账号名称或者全名！",
        "新密码不能是当前密码！":"新密码不能是当前密码！",
        "新密码不能是最近已使用的24个密码！":"新密码不能是最近已使用的24个密码！",
        "原密码不正确":"原密码不正确",
        "change501":"新创建账号和重置密码账号需先修改密码，才能访问系统。",
        "change502":"距上次修改密码已超过90天，请先修改密码。"
    },
    loginTips:{
        "请输入正确的账号或密码！":"请输入正确的账号或密码！",
        "该账号已被冻结！":"该账号已被冻结！",
        "该账号未绑定邮箱，无法登陆":"该账号未绑定邮箱，无法登陆",
        "该账号已被锁定":"该账号已被锁定",
        "登录失败！":"登录失败！",
        "sso类型账号请使用sso登录！":"sso类型账号请使用sso登录！"
    },
    maintain:{
        "timeRange":"服务时间范围",
        "openTime":"开机时间",
        "maintainType":"服务类型",
        "orderCode":"服务编号",
        "serviceContent":"服务内容",
        "runningHour":"设备运行时长",
        "serviceTime":"服务时间"
    },
    insight:{
        "已运行时长":"已运行时长",
        "上次更换日":"上次更换日",
        "上次更换运行时长":"上次更换运行时长",
        "推荐更换周期":"推荐更换周期",
        "首次预报警时间":"首次预报警时间",
        "末次预报警时间":"末次预报警时间",
        "建议":"建议",
        "前两周低气压状态占比":"前两周低气压状态占比",
        "后两周低气压状态占比":"后两周低气压状态占比",
        "日（告警时间）":"日（告警时间）",
        "告警信息":"告警信息",
        "原因":"原因",
        "解决方案":"解决方案",
        "频繁开关机":"频繁开关机",
        "机组排期压力":"机组排期压力",
        "长时间卸载":"长时间卸载",
        "频繁加卸载":"频繁加卸载",
        "油分":"油分",
        "油滤":"油滤",
        "空滤":"空滤",
        "冷却风进气温度":"冷却风进气温度",
        "总分":"总分",
        "利用率":"利用率",
        "管路":"管路",
        "电机":"电机",
        "进气阀":"进气阀",
        "温控阀":"温控阀",
        "最小压力阀（有油）":"最小压力阀（有油）",
        "放空阀（无油）":"放空阀（无油）",
        "中冷（无油）":"中冷（无油）",
        "后冷":"后冷",
        "油冷":"油冷",
        "油分离桶（有油）":"油分离桶（有油）",
        "定频":"定频",
        "变频1":"变频1",
        "变频2":"变频2",
        "来源-2":"来源-2",
        "insightTitle21":"设备操作报告 --- 总分分布统计",
        "insightTitle27":"利用率异常（高/低）预警 --- 利用率分布统计",
        "insightTitle29":"频繁加卸载 --- 次数分布统计"
    },
    overhaul:{
        tab:"大修倒计时",
        listColumn:"大修倒计时",
        cycleColumn:"大修周期",
        cycleConfig:"大修周期配置",
        item:"倒计时项",
        itemEnable:"启用",
        cycleHours:"周期(运行小时)",
        warnAheadHours:"预警提前(小时)",
        baseRunningHours:"复位基准(小时)",
        targetRunningHours:"目标(小时)",
        warnRunningHours:"预警阈值(小时)",
        currentRunningHours:"当前运行小时",
        remainingHours:"剩余小时",
        status:"状态",
        statusNormal:"正常",
        statusWarn:"预警",
        statusOverdue:"超期",
        warnCountText:"预警{n}项",
        overdueCountText:"超期{n}项",
        countSeparator:"、",
        filterHasData:"有倒计时数据",
        filterTriggered:"已触发(预警+超期)",
        cycleSource:"周期来源",
        cycleInherited:"继承机型",
        cycleCustomized:"设备自定义",
        modelDefault:"机型默认",
        baselinePending:"基准待日结回填",
        baselinePendingTip:"复位基准以复位当日24点总运行小时为准。当前显示的是复位时刻的临时基准，次日定时任务回填后自动校正。",
        lastResetTime:"上次复位时间",
        syncTime:"同步时间",
        lastResetUser:"复位人",
        reset:"复位",
        resetAll:"一键复位",
        resetToModelDefault:"重置为机型默认值",
        resetConfirm:"确认复位该倒计时项？复位后以当日24点总运行小时为新基准重新起算。",
        resetAllConfirm:"确认复位该设备全部倒计时项？复位后全部项以当日24点总运行小时为新基准重新起算，操作不可撤销。",
        resetToModelDefaultConfirm:"确认将周期恢复为机型默认值？",
        resetRemark:"备注(工单号、更换件号等)",
        resetSuccess:"复位成功",
        saveCycleSuccess:"周期保存成功",
        editCycle:"修改周期",
        batchSetCycle:"批量设置周期",
        importCycle:"导入周期",
        exportCycle:"导出周期",
        selectModelTip:"请先勾选要设置的机型",
        selectItemTip:"请选择要设置的倒计时项",
        allItems:"全部倒计时项",
        itemCodesEmptyTip:"不选则表示对全部启用的倒计时项生效",
        applyToInheritedDevices:"同时下发到未自定义周期的设备",
        applyToInheritedDevicesTip:"勾选后立即更新该机型下「继承机型默认值」的设备；已自定义周期的设备不受影响。",
        cycleInvalid:"周期必须为大于0的整数",
        warnAheadInvalid:"预警提前小时数必须为非负整数且小于周期",
        batchSetSuccess:"批量设置成功",
        importSuccess:"导入完成",
        importTemplateTip:"导入列：品牌编码、产品线、产品大类、产品小类、机型、倒计时项(编码或名称)、周期、预警提前小时",
        importFileTip:"仅支持 .xlsx / .xls 文件",
        importRow:"行号",
        importErrorMsg:"失败原因",
        importSuccessCount:"成功行数",
        importFailCount:"失败行数",
        resetHistory:"复位历史",
        resetType:"复位方式",
        resetTypeSingle:"单项复位",
        resetTypeAll:"一键复位",
        resetDate:"复位日期",
        resetRunningHours:"复位时运行小时",
        preTarget:"复位前目标(小时)",
        noData:"该设备暂无倒计时数据，请先在机型管理中配置大修周期",
        noModelCycleTip:"该机型未配置大修周期",
        dictEmptyTip:"尚未配置倒计时项字典，请先在数据库执行倒计时项初始化脚本（Sys_BnDict，BnTypeCode=OverhaulItem）",
        exportFileName:"机型大修周期",
        exportDeviceFileName:"设备大修倒计时"
    },
    gatherUnit:{
        "inputUnit":"输入单位",
        "outputUnit":"输出单位",
        "offset":"偏移量",
        "scale":"缩放量",
        "addFormula":"新增公式",
        "editFormula":"修改公式",
    },
    formula:{
        "注册总数":"安装物联网装置并绑定的设备总台数",
        "在线数":"30天内运行时间大于等于10小时的设备数量",
        "未连接数":"30天内运行时间小于10小时的设备数量",
        "警告台数":"本月出现过告警，或有未解除告警的设备数量",
        "故障台数":"本月出现过故障，或有未解除故障的设备数量",
        "空压机健康度":"（在线数-在线故障台数）÷在线数",
        "客户月利用率":"上月所有设备的日利用率平均值（日利用率=单日运行小时数÷24小时）",
        "单台设备日利用率":"(该设备当天运行时间读数-前一天运行时间读数)÷24",
        "单台设备月利用率":"上月日利用率平均值（日利用率=单日运行小时数÷24小时）",
        "单台设备月加载率":"上月加载时长÷运行时长",
        "最近12个月单台设备月利用率":"最近12个月中每月运行日的日利用率平均值（日利用率=单日运行小时数÷24小时）",
        "最近12个月单台设备月加载率":"月加载率=月加载时长÷月运行时长",
    },
    web:{
        viewMonitor:"查看监测",
        warnMonitor:"故障监测",
        monitorChart:"监测图表",
        MonitoringDate:"监测日期",
        MonitoringParameters:"监测参数",
        realtimemonitoring:"实时监测",
        historymonitoring:"历史监测",
        monitortableDetail:"监测详细数据",
        selectMonitoringParameters:"请选择监测参数",
        monitorIndex: "监测指标",
        monitorDataDetail:"监测数据详情",
        DeviceMonitorManagement_View: "设备监测",
    },
    multiBrand:{
        ACIoTMP:"产品物联网管理平台",
        ACDMap:"产品分布图",
        totalShipment:"已发货",
        registration:"产品注册率",
        online:"在线率",
        warning:"告警数",
        trip:"故障数",
        utilization:"产品利用率",
        offline:"离线数"
    },
    alarmPushRule:{
        ruleCode:"规则编码",
        ruleName:"规则名称",
        isPush:"是否推送",
        isRepeat:"是否重复推送",
        cycleValue:"推送沉默周期",
        cycleUnit:"周期单位",
        cycleCondition:"周期推送条件",
        isAttachAlarmMsg:"是否附带告警快照",
        hour:"小时",
        day:"天",
        week:"周",
        month:"月",
        addRule:"新增规则",
        editRule:"修改规则",
        range:"范围",
        all:"所有",
        customize:"自定义",
        ruleDetail:"告警推送SFA规则详细",
        bindCcnErrorInfo: "选择报错信息",
    },
    city:{
        北京: "北京",
        上海: "上海",
        天津: "天津",
        重庆: "重庆",
        西藏: "西藏",
        拉萨: "拉萨",
        阿里地区: "阿里地区",
        山南: "山南",
        昌都: "昌都",
        日喀则: "日喀则",
        那曲: "那曲",
        林芝: "林芝",
        新疆: "新疆",
        乌鲁木齐: "乌鲁木齐",
        克拉玛依: "克拉玛依",
        吐鲁番: "吐鲁番",
        哈密: "哈密",
        昌吉回族自治州: "昌吉回族自治州",
        博尔塔拉蒙古自治州: "博尔塔拉蒙古自治州",
        巴音郭楞蒙古自治州: "巴音郭楞蒙古自治州",
        阿克苏地区: "阿克苏地区",
        克孜勒苏柯尔克孜自治州: "克孜勒苏柯尔克孜自治州",
        喀什地区: "喀什地区",
        和田地区: "和田地区",
        伊犁哈萨克自治州: "伊犁哈萨克自治州",
        塔城地区: "塔城地区",
        阿勒泰地区: "阿勒泰地区",
        石河子: "石河子",
        阿拉尔: "阿拉尔",
        图木舒克: "图木舒克",
        五家渠: "五家渠",
        北屯: "北屯",
        铁门关: "铁门关",
        双河: "双河",
        可克达拉: "可克达拉",
        昆玉: "昆玉",
        胡杨河: "胡杨河",
        甘肃: "甘肃",
        兰州: "兰州",
        临夏回族自治州: "临夏回族自治州",
        金昌: "金昌",
        张掖: "张掖",
        酒泉: "酒泉",
        定西: "定西",
        甘南藏族自治州: "甘南藏族自治州",
        白银: "白银",
        陇南: "陇南",
        天水: "天水",
        庆阳: "庆阳",
        嘉峪关: "嘉峪关",
        武威: "武威",
        平凉: "平凉",
        陕西: "陕西",
        西安: "西安",
        汉中: "汉中",
        咸阳: "咸阳",
        榆林: "榆林",
        安康: "安康",
        延安: "延安",
        宝鸡: "宝鸡",
        商洛: "商洛",
        渭南: "渭南",
        铜川: "铜川",
        四川: "四川",
        成都: "成都",
        自贡: "自贡",
        攀枝花: "攀枝花",
        泸州: "泸州",
        德阳: "德阳",
        绵阳: "绵阳",
        广元: "广元",
        遂宁: "遂宁",
        内江: "内江",
        乐山: "乐山",
        南充: "南充",
        眉山: "眉山",
        宜宾: "宜宾",
        广安: "广安",
        达州: "达州",
        雅安: "雅安",
        巴中: "巴中",
        资阳: "资阳",
        阿坝藏族羌族自治州: "阿坝藏族羌族自治州",
        甘孜藏族自治州: "甘孜藏族自治州",
        凉山彝族自治州: "凉山彝族自治州",
        广西: "广西",
        南宁: "南宁",
        柳州: "柳州",
        桂林: "桂林",
        梧州: "梧州",
        北海: "北海",
        防城港: "防城港",
        钦州: "钦州",
        贵港: "贵港",
        玉林: "玉林",
        百色: "百色",
        贺州: "贺州",
        河池: "河池",
        来宾: "来宾",
        崇左: "崇左",
        河南: "河南",
        郑州: "郑州",
        开封: "开封",
        洛阳: "洛阳",
        平顶山: "平顶山",
        安阳: "安阳",
        鹤壁: "鹤壁",
        新乡: "新乡",
        焦作: "焦作",
        濮阳: "濮阳",
        许昌: "许昌",
        漯河: "漯河",
        三门峡: "三门峡",
        南阳: "南阳",
        商丘: "商丘",
        信阳: "信阳",
        周口: "周口",
        驻马店: "驻马店",
        济源: "济源",
        内蒙古: "内蒙古",
        赤峰: "赤峰",
        呼伦贝尔: "呼伦贝尔",
        兴安盟: "兴安盟",
        呼和浩特: "呼和浩特",
        包头: "包头",
        乌海: "乌海",
        通辽: "通辽",
        鄂尔多斯: "鄂尔多斯",
        巴彦淖尔: "巴彦淖尔",
        乌兰察布: "乌兰察布",
        锡林郭勒盟: "锡林郭勒盟",
        阿拉善盟: "阿拉善盟",
        吉林: "吉林",
        长春: "长春",
        四平: "四平",
        辽源: "辽源",
        通化: "通化",
        白山: "白山",
        松原: "松原",
        白城: "白城",
        延边朝鲜族自治州: "延边朝鲜族自治州",
        浙江: "浙江",
        杭州: "杭州",
        宁波: "宁波",
        温州: "温州",
        嘉兴: "嘉兴",
        湖州: "湖州",
        绍兴: "绍兴",
        金华: "金华",
        衢州: "衢州",
        舟山: "舟山",
        台州: "台州",
        丽水: "丽水",
        江西: "江西",
        南昌: "南昌",
        景德镇: "景德镇",
        萍乡: "萍乡",
        九江: "九江",
        新余: "新余",
        鹰潭: "鹰潭",
        赣州: "赣州",
        吉安: "吉安",
        宜春: "宜春",
        抚州: "抚州",
        上饶: "上饶",
        湖北: "湖北",
        武汉: "武汉",
        黄石: "黄石",
        十堰: "十堰",
        宜昌: "宜昌",
        襄阳: "襄阳",
        鄂州: "鄂州",
        荆门: "荆门",
        孝感: "孝感",
        荆州: "荆州",
        黄冈: "黄冈",
        咸宁: "咸宁",
        随州: "随州",
        仙桃: "仙桃",
        潜江: "潜江",
        天门: "天门",
        恩施土家族苗族自治州: "恩施土家族苗族自治州",
        神农架林区: "神农架林区",
        广东: "广东",
        广州: "广州",
        韶关: "韶关",
        深圳: "深圳",
        珠海: "珠海",
        汕头: "汕头",
        佛山: "佛山",
        江门: "江门",
        湛江: "湛江",
        茂名: "茂名",
        肇庆: "肇庆",
        惠州: "惠州",
        梅州: "梅州",
        汕尾: "汕尾",
        河源: "河源",
        阳江: "阳江",
        清远: "清远",
        东莞: "东莞",
        中山: "中山",
        潮州: "潮州",
        揭阳: "揭阳",
        云浮: "云浮",
        贵州: "贵州",
        贵阳: "贵阳",
        遵义: "遵义",
        六盘水: "六盘水",
        安顺: "安顺",
        毕节: "毕节",
        铜仁: "铜仁",
        黔西南布依族苗族自治州: "黔西南布依族苗族自治州",
        黔东南苗族侗族自治州: "黔东南苗族侗族自治州",
        黔南布依族苗族自治州: "黔南布依族苗族自治州",
        青海: "青海",
        西宁: "西宁",
        海东: "海东",
        海北藏族自治州: "海北藏族自治州",
        黄南藏族自治州: "黄南藏族自治州",
        海南藏族自治州: "海南藏族自治州",
        果洛藏族自治州: "果洛藏族自治州",
        玉树藏族自治州: "玉树藏族自治州",
        海西蒙古族藏族自治州: "海西蒙古族藏族自治州",
        辽宁: "辽宁",
        沈阳: "沈阳",
        大连: "大连",
        鞍山: "鞍山",
        抚顺: "抚顺",
        本溪: "本溪",
        丹东: "丹东",
        锦州: "锦州",
        营口: "营口",
        阜新: "阜新",
        辽阳: "辽阳",
        盘锦: "盘锦",
        铁岭: "铁岭",
        朝阳: "朝阳",
        葫芦岛: "葫芦岛",
        江苏: "江苏",
        南京: "南京",
        无锡: "无锡",
        徐州: "徐州",
        常州: "常州",
        南通: "南通",
        苏州: "苏州",
        连云港: "连云港",
        淮安: "淮安",
        盐城: "盐城",
        扬州: "扬州",
        镇江: "镇江",
        泰州: "泰州",
        宿迁: "宿迁",
        安徽: "安徽",
        合肥: "合肥",
        芜湖: "芜湖",
        蚌埠: "蚌埠",
        淮南: "淮南",
        马鞍山: "马鞍山",
        淮北: "淮北",
        铜陵: "铜陵",
        安庆: "安庆",
        黄山: "黄山",
        滁州: "滁州",
        阜阳: "阜阳",
        宿州: "宿州",
        六安: "六安",
        亳州: "亳州",
        池州: "池州",
        宣城: "宣城",
        河北: "河北",
        石家庄: "石家庄",
        唐山: "唐山",
        秦皇岛: "秦皇岛",
        邯郸: "邯郸",
        邢台: "邢台",
        保定: "保定",
        张家口: "张家口",
        承德: "承德",
        沧州: "沧州",
        廊坊: "廊坊",
        衡水: "衡水",
        山西: "山西",
        太原: "太原",
        大同: "大同",
        阳泉: "阳泉",
        长治: "长治",
        晋城: "晋城",
        朔州: "朔州",
        晋中: "晋中",
        运城: "运城",
        忻州: "忻州",
        临汾: "临汾",
        吕梁: "吕梁",
        黑龙江: "黑龙江",
        哈尔滨: "哈尔滨",
        齐齐哈尔: "齐齐哈尔",
        鹤岗: "鹤岗",
        鸡西: "鸡西",
        双鸭山: "双鸭山",
        大庆: "大庆",
        伊春: "伊春",
        佳木斯: "佳木斯",
        七台河: "七台河",
        牡丹江: "牡丹江",
        黑河: "黑河",
        绥化: "绥化",
        大兴安岭地区: "大兴安岭地区",
        福建: "福建",
        福州: "福州",
        厦门: "厦门",
        莆田: "莆田",
        三明: "三明",
        泉州: "泉州",
        漳州: "漳州",
        南平: "南平",
        龙岩: "龙岩",
        宁德: "宁德",
        山东: "山东",
        济南: "济南",
        青岛: "青岛",
        淄博: "淄博",
        枣庄: "枣庄",
        东营: "东营",
        烟台: "烟台",
        潍坊: "潍坊",
        济宁: "济宁",
        泰安: "泰安",
        威海: "威海",
        日照: "日照",
        临沂: "临沂",
        德州: "德州",
        聊城: "聊城",
        滨州: "滨州",
        菏泽: "菏泽",
        湖南: "湖南",
        长沙: "长沙",
        株洲: "株洲",
        湘潭: "湘潭",
        衡阳: "衡阳",
        邵阳: "邵阳",
        岳阳: "岳阳",
        常德: "常德",
        张家界: "张家界",
        益阳: "益阳",
        郴州: "郴州",
        永州: "永州",
        怀化: "怀化",
        娄底: "娄底",
        湘西土家族苗族自治州: "湘西土家族苗族自治州",
        海南: "海南",
        海口: "海口",
        三亚: "三亚",
        三沙: "三沙",
        儋州: "儋州",
        五指山: "五指山",
        琼海: "琼海",
        文昌: "文昌",
        万宁: "万宁",
        东方: "东方",
        定安县: "定安县",
        屯昌县: "屯昌县",
        澄迈县: "澄迈县",
        临高县: "临高县",
        白沙黎族自治县: "白沙黎族自治县",
        昌江黎族自治县: "昌江黎族自治县",
        乐东黎族自治县: "乐东黎族自治县",
        陵水黎族自治县: "陵水黎族自治县",
        保亭黎族苗族自治县: "保亭黎族苗族自治县",
        琼中黎族苗族自治县: "琼中黎族苗族自治县",
        云南: "云南",
        昆明: "昆明",
        曲靖: "曲靖",
        玉溪: "玉溪",
        保山: "保山",
        昭通: "昭通",
        丽江: "丽江",
        普洱: "普洱",
        临沧: "临沧",
        楚雄彝族自治州: "楚雄彝族自治州",
        红河哈尼族彝族自治州: "红河哈尼族彝族自治州",
        文山壮族苗族自治州: "文山壮族苗族自治州",
        西双版纳傣族自治州: "西双版纳傣族自治州",
        大理白族自治州: "大理白族自治州",
        德宏傣族景颇族自治州: "德宏傣族景颇族自治州",
        怒江傈僳族自治州: "怒江傈僳族自治州",
        迪庆藏族自治州: "迪庆藏族自治州",
        宁夏: "宁夏",
        银川: "银川",
        石嘴山: "石嘴山",
        吴忠: "吴忠",
        固原: "固原",
        中卫: "中卫",
        香港: "香港",
        澳门: "澳门",
        中国台湾: "台湾",
        台北: "台北",
        高雄: "高雄",
        基隆: "基隆",
        台中: "台中",
        台南: "台南",
        新竹: "新竹",
        嘉义: "嘉义",
        新北: "新北",
        桃园: "桃园",
    },
    importError: {
        dsnIsEmpty: "产品序列号为空",
        ccnIsEmpty: "ccn号为空",
        errorCodeIsEmpty: "故障代码为空",
        errorDescriptionIsEmpty: "故障描述为空",
        errorTypeIsEmpty: "故障类型为空",
        expertAdviceIsEmpty: "专家建议为空",
        "theSameCcnAlreadyExists": " 已存在相同的Ccn和Ccn版本号",
        monitorIndexIsEmpty: "监控指标为空",
        companyCodeIsEmpty: "公司代码为空",
        companyNameIsEmpty: "，公司名称为空",
        customerCodeIsEmpty: "客户代码为空",
        customerNameIsEmpty: "，客户名称为空",
        customerCharaterIsEmpty: "，单位性质为空",
        gsnIsEmpty: "网关SN号为空",
        runningTimeError: "运行时间出错",
        runningTimeinteger: "运行时间必须为整数",
        devicesnIsEmpty: "设备SN号为空",
        "exceptionLine":"Excel表格读取数据第",
        "exceptionSheet":"Excel表格读取",
        "数据第": "数据第",
        "行异常:":"行异常:",
        "已存在": "已存在",
        "客户代码":"客户代码",
        "单位性质":"单位性质",
        "管理单位代码":"管理单位代码",
        "相同的数据":"相同的数据",
        "theSameDsnAlreadyExists": " 已存在相同的产品序列号",
        "theSameCustomerCodeAlreadyExists": " 已存在相同的公司代码",
        "theSameGsnAlreadyExists": " 已存在相同的网关SN号",
        "readFailCcn":"Excel表格读取失败，未找到“点表”和“错误信息”的Sheet",
        "readFailExpertAdvice":"Excel表格读取失败，未找到“专家建议”的Sheet",
        "only":"只能选择",
        "selectAgain":"个文件，请先删除文件后重新选择",
        "onlySelect": "只能选择xlsx、xls的文件",
    },
    exportContent: {
        "监控历史数据": "监控历史数据",
        "空压机服务明细":"产品服务明细",
        "告警信息列表": "告警信息列表",
        "点表导出": "点表导出",
        "点表总目录导出": "点表总目录导出",
        "defaultOrNot":"是否默认",
        "BV客户区域列表":"BV客户区域列表",
        "Rotary客户区域列表":"Rotary客户区域列表",
        "经销商列表导出": "经销商列表导出",
        "客户列表导出": "客户列表导出",
        "PAC客户区域列表": "PAC客户区域列表",
        "空压机机型列表": "产品机型列表",
        "耐久性测试设备登记列表": "耐久性测试设备登记列表",
        "空压机网关列表": "产品网关列表",
        "OTA升级任务": "OTA升级任务",
        "升级结果导出": "升级结果导出",
        "预测维护空压机列表导出": "预测维护产品列表导出",
        "解绑空压机列表": "解绑产品列表",
        "解绑详细列表":"解绑详细列表",
        "整体趋势图": "整体趋势图",
        "工厂安装趋势图": "工厂安装趋势图",
        "现场安装趋势图": "现场安装趋势图",
        "各行业利用率":"各行业利用率",
        "各客户中心利用率":"各客户中心利用率",
        "用户列表": "用户列表",
        "维护记录表": "维护记录表",
    },
    coodMode: {
        "风冷": "风冷",
        "水冷": "水冷",
        "":"",
        "undefined":"",
        "unll": "",
    },
    eightSpan:{
        BS5DH0:"机组排气压力",
        BM2000:"机组状态",
        SVT0:"入口压力",
        IDP0:"机组状态",
        BS5DH1:"运行时间",
        BM2001:"叶轮进气压力",
        SVT1:"主机排气压力",
        IDP1:"运行时间（Hours）",
        BS5DH2:"加载时间",
        BM2002:"叶轮进气温度",
        SVT2:"喷油压力",
        IDP2:"加载时间（Hours）",
        BS5DH3:"主机排气压力",
        BM2003:"机组排气压力",
        SVT3:"目标压力",
        IDP3:"真空泵入口压力",
        BS5DH4:"额定压力",
        BM2004:"主电机绕组温度",
        SVT4:"运行时间",
        IDP4:"目标压力",
        BS5DH5:"主机排气温度",
        BM2005:"当前流量",
        SVT5:"主机变频器电机电流",
        IDP5:"真空泵壳体温度",
        BS5DH6:"压缩比",
        BM2006:"主机变频器电机转速",
        SVT6:"主机变频器电机电压",
        IDP6:"主机变频器电机转速",
        MC0:"机组状态",
        MC1:"机组排气压力",
        MC2:"压力设定值",
        MC3:"4级排气温度",
        MC4:"环境空气温度",
        MC5:"主电机1转速",
        MC6:"主电机2转速",
        LR0:"机组状态",
        LR1:"高压级满载运行小时",
        LR2:"高压级排气压力",
        LR3:"冷却水温度",
        LR4:"最近12个月利用率",
        LR5:"累计运行小时",
        LR6:"高压级半载运行小时",
        LR7:"高压级半载停止设定值",
        LR8:"保养小时",
        LR9:"电机启动次数"
    }
}
